import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const UserTableRowStyles = makeStyles((theme: Theme) =>
    createStyles({
        row: {
            "& > .MuiTableCell-root": {
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                "&:nth-child(5)": {
                    paddingRight: 0,
                },
                "&:nth-child(6)": {
                    paddingLeft: 0,
                },
            },
            "&:hover > .MuiTableCell-root": {
                backgroundColor: theme.palette.background.grey,
                transition: `background-color 0.3s`,
                "& $actionBtn": {
                    opacity: 1,
                },
            },
        },
        progressBar: {
            backgroundColor: theme.palette.neutrals.light,
            maxWidth: 200,
            height: 8,
            borderRadius: 10,
            "& .MuiLinearProgress-bar": {
                backgroundColor: theme.palette.primary.main,
                borderRadius: "inherit",
            },
        },
        progressBarComplete: {
            "& .MuiLinearProgress-bar": {
                backgroundColor: theme.palette.primary.main,
            },
        },
        reminderButton: {
            minWidth: "max-content",
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
            padding: 0,
            height: 32,
            "&:hover": {
                fontWeight: 400,
                textShadow: `0 0 0.8px currentColor`,
            },
        },
        expandableRow: {
            "& .MuiTableCell-root": {
                background: theme.palette.background.grey,
                padding: theme.spacing(0, 3),
                borderBottom: `1px solid ${theme.palette.neutrals.light}`,
            },
            "& .MuiTypography-root": {
                fontSize: 12,
                fontWeight: 600,
            },
        },
        removeUserButton: {
            "& .MuiSvgIcon-root": {
                fontSize: 18,
            },
            color: theme.palette.text.disabled,
            "&:hover": {
                color: theme.palette.error.main,
            },
        },
        toggleCloseBtn: {
            "& .MuiSvgIcon-root": {
                fontSize: 10,
                color: theme.palette.neutrals.dark,
            },
        },
        paceInfoPopper: {
            maxWith: "auto",
        },
        paceInfoWrapper: {
            maxWidth: 350,
        },
        paceInfoInner: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
        },
        paceInfoDescription: {
            fontSize: 12,
            fontWeight: 400,
            paddingRight: theme.spacing(1),
        },
        paceInfoCloseButton: {
            color: theme.palette.common.white,
            "& .MuiSvgIcon-root": {
                fontSize: 12,
            },
        },
        actionBtn: {
            opacity: 0,
            color: theme.palette.button.active.from,
            transition: `opacity 0.3s`,
        },
        actionBtn1: {
            fontSize: 16,
        },
        actionBtn2: {
            fontSize: 20,
        },
    })
);

export default UserTableRowStyles;
